import { Checkbox, Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { IExerciseOption } from '../../../../types/interfaces/exercise-option';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (option: IExerciseOption) => void,
  onDelete: (option: IExerciseOption) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.NAME,
      cellReducer: (option: IExerciseOption) => {
        return <div className={classes.name}>{option.name}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.NAME_KEY,
      cellReducer: (option: IExerciseOption) => {
        return <div className={classes.nameKey}>{option.nameKey}</div>;
      },
    },

    {
      id: TABLE_COLUMNS_IDS.UNIT,
      cellReducer: (option: IExerciseOption) => {
        return <div className={classes.unit}>{option.unit}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.UNIT_KEY,
      cellReducer: (option: IExerciseOption) => {
        return <div className={classes.unitKey}>{option.unitKey}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.TYPE,
      cellReducer: (option: IExerciseOption) => {
        return <div className={classes.type}>{option.type}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.PRIORITY_ORDER,
      cellReducer: (option: IExerciseOption) => {
        return (
          <div className={classes.priorityOrder}>{option.priorityOrder}</div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.DEFAULT,
      cellReducer: (option: IExerciseOption) => {
        return (
          <div className={classes.default}>
            <Checkbox disabled checked={option.default}></Checkbox>
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIVE,
      cellReducer: (option: IExerciseOption) => {
        return (
          <div className={classes.active}>
            <Checkbox disabled checked={option.active}></Checkbox>
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (option: IExerciseOption) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(option);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(option);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
